module.exports = __webpack_public_path__ + "media/images/icon_facebook-34dcec37b60b888ee900ef9a93966ad9.svg";